<template>

<component-module moduleName="website_module">
    <template v-slot:programName>Website</template>
    <template v-slot:navigation>
        <div v-if="getAdministratorFlag">Welcome Admin!</div>
        <div v-else>
        <div class="main-nav">
            <template v-for="(menuItem, index) in sort0">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-list"></i> Site Includes</div>
            <template v-for="(menuItem) in sort1">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-home"></i> Home Page Only</div>
            <template v-for="(menuItem) in sort2">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-cog"></i> Settings</div>
            <template v-for="(menuItem) in sort3">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        </div>
    </template>
</component-module>

</template>

<script>
import './website.scss'
export default {
    created() {
        this.updateCustomModuleName('Website');
    },
    computed: {
        sort0() {
            if (!this.getModuleNavMenu.sort_0) return {}
            return this.getModuleNavMenu.sort_0.menu_items
        },
        sort1() {
            if (!this.getModuleNavMenu.sort_1) return {}
            return this.getModuleNavMenu.sort_1.menu_items
        },
        sort2() {
            if (!this.getModuleNavMenu.sort_2) return {}
            return this.getModuleNavMenu.sort_2.menu_items
        },
        sort3() {
            if (!this.getModuleNavMenu.sort_3) return {}
            return this.getModuleNavMenu.sort_3.menu_items
        },
        dashboardMenuItem() {
            for (const [key, menuItem] of Object.entries(this.getFlightDeckMainMenu)) {
                if (menuItem.link_value == 'website') {
                    return menuItem
                }
            }
        }
    }
}
</script>

<style>

</style>
